import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement } from 'react';
import { useInView } from 'react-intersection-observer';
export const Marquee = ({ itemWidth, gap = 40, speed, children }) => {
    const [ref, isInView] = useInView();
    const childrenCount = Children.count(children);
    const duration = (childrenCount * itemWidth) / (speed || 5);
    return (_jsx("div", { className: "group relative h-full w-full overflow-hidden", children: _jsx("ul", { ref: ref, className: "marquee-track group-hover:[animation-play-state:paused]", style: {
                '--marquee-duration': `${duration}s`,
                '--marquee-play-state': isInView ? 'running' : 'paused',
            }, children: Array(4)
                .fill(null)
                .map((_, chunkIndex) => Children.map(children, (child, index) => (_jsx("li", { className: "marquee-item flex flex-1 items-center justify-center", style: { '--marquee-item-gap': `${gap}px` }, children: cloneElement(child, chunkIndex > 0
                    ? { tabIndex: -1, 'aria-hidden': true }
                    : undefined) }, `${chunkIndex}-${index}`)))) }) }));
};
